import React from "react";
import { connect } from "react-redux";
import { FooterIconButton } from "../../../base/buttons";
import { translate } from "../../../base/i18n";
import { isCheckPermission } from "../../../base/localuser";
import { PERMISSION } from "../../../base/participants";
import { documentLayoutList, getCurrentMode, setVideoLayoutMode, videoLayoutMode } from "../../../video-layout-mode";

function SwitchShareDocumentButton({ t, dispatch, mode, prevDocumentMode, prevLayoutMode, isLayoutPermission, isShared }) {
    const startDocumentShare = () => {
        APP.UI.closeModal();
        
        if (isLayoutPermission) { 
            if (!isShared) {
                dispatch(setVideoLayoutMode(prevDocumentMode));
                return;
            }

            dispatch(setVideoLayoutMode(prevLayoutMode));
            return;
        }
    }

    return (
        <FooterIconButton mode="document" name={t("conference.documentShare")} checked={isShared} onClick={startDocumentShare} />
    )
}

function _mapStateToProps(state) {
    const mode = getCurrentMode(state);
    const { prevLayoutMode, prevDocumentMode } = state['features/video-layout-mode'] || videoLayoutMode.default;

    const isLayoutPermission = isCheckPermission(state, PERMISSION.SHARE);
    const isShared = documentLayoutList.indexOf(mode) !== -1;
    
    return {
        prevLayoutMode, prevDocumentMode,
        mode,
        isLayoutPermission,
        isShared
    }
}

export default translate(connect(_mapStateToProps)(SwitchShareDocumentButton));